<template>
  <div class="lang-switcher" aria-label="Language selector">
    <button
      type="button"
      class="lang-btn"
      :class="{ active: currentLocale === 'ja' }"
      @click="changeLocale('ja')"
      title="日本語に切り替え"
    >
      JP
    </button>
    <span class="lang-divider">/</span>
    <button
      type="button"
      class="lang-btn"
      :class="{ active: currentLocale === 'en' }"
      @click="changeLocale('en')"
      title="Switch to English"
    >
      EN
    </button>
  </div>
</template>

<script>
import { setLocale } from '@/i18n';

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      currentLocale: this.$i18n ? this.$i18n.locale : 'ja'
    };
  },
  mounted() {
    // 外部や別コンポーネントからの言語変更イベントを同期
    window.addEventListener('locale-changed', this.handleLocaleChanged);
  },
  beforeUnmount() {
    window.removeEventListener('locale-changed', this.handleLocaleChanged);
  },
  methods: {
    changeLocale(locale) {
      if (this.currentLocale !== locale) {
        this.currentLocale = locale;
        if (this.$i18n) {
          this.$i18n.locale = locale;
        }
        setLocale(locale);
      }
    },
    handleLocaleChanged(event) {
      if (event.detail && event.detail.locale) {
        this.currentLocale = event.detail.locale;
      }
    }
  }
};
</script>

<style scoped>
.lang-switcher {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  padding: 2px 6px;
  z-index: 10;
  line-height: 1;
}

.lang-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.2s ease-in-out;
  outline: none;
  letter-spacing: 0.5px;
}

.lang-btn:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

.lang-btn.active {
  color: darkblue;
  background: #ffffff;
  font-weight: 700;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.lang-divider {
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  margin: 0 1px;
  user-select: none;
}

@media (max-width: 576px) {
  .lang-switcher {
    right: 8px;
    padding: 2px 4px;
  }
  .lang-btn {
    font-size: 10px;
    padding: 2px 4px;
  }
}
</style>
